import ApiClient from './client';

const createApiAction = details => ({
  ...details,
  [ApiClient.ACTION_KEY]: true,
});

export default createApiAction;
